var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"note-list"},_vm._l((_vm.notes),function(note){return _c('notes-item',{key:note.id,attrs:{"note":note},on:{"editNote":_vm.editNote,"deleteNote":_vm.deleteNote}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }